import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_CRESCENT } from "./data";
import { SocialLinks } from "./SocialLinks";
import { BagButton } from "./cart/CartDrawer";

export const PageHeader = ({ page, backLabel = "Home", link }) => (
  <header data-testid={`${page}-header`} className="fixed top-0 inset-x-0 z-50 bg-[#ffffff]/80 backdrop-blur-md border-b border-[#e3e2dc]">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-16 grid grid-cols-[1fr_auto_1fr] items-center gap-3">
      <Link to="/" data-testid={`${page}-back-link`} className="inline-flex items-center gap-2 font-mono-d text-[10px] uppercase tracking-[0.2em] text-[#5f5e5a] hover:text-[#ff2a85] transition-colors justify-self-start whitespace-nowrap">
        <ArrowLeft size={14} /> <span className="hidden sm:inline">{backLabel}</span><span className="sm:hidden">Home</span>
      </Link>
      <Link to="/" className="flex items-center gap-2.5 justify-self-center">
        <img src={LOGO_CRESCENT} alt="Deen District" className="h-8 w-8 object-contain" />
        <span className="font-display text-[12px] font-extrabold tracking-[0.18em] uppercase hidden sm:inline">Deen District</span>
      </Link>
      <div className="flex items-center gap-3 sm:gap-4 justify-self-end">
        {link && (
          <Link to={link.to} data-testid={`${page}-${link.id}-link`} className="hidden sm:inline font-mono-d text-[10px] uppercase tracking-[0.2em] text-[#5f5e5a] hover:text-[#ff2a85] transition-colors whitespace-nowrap">
            {link.label}
          </Link>
        )}
        <SocialLinks prefix={page} size="sm" className="gap-2 sm:gap-3" />
        <BagButton testId={`${page}-bag-button`} />
      </div>
    </div>
  </header>
);
